(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aseone-shop-by-style"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Register once only (safe for theme editor reloads) */
    if (!window.customElements || window.customElements.get('caseone-shop-by-style')) return;

    var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    class CaseOneShopByStyle extends HTMLElement {
      connectedCallback() {
        this.cleanups = [];
        this.reduce = !!(reduceQuery && reduceQuery.matches);
        this.track = this.querySelector('[data-ch-sbs-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-ch-sbs-prev]');
        this.next = this.querySelector('[data-ch-sbs-next]');
        this.bar = this.querySelector('[data-ch-sbs-bar]');
        this.progress = this.querySelector('.ch-sbs__progress');
        this.items = Array.prototype.slice.call(this.querySelectorAll('.ch-sbs__item'));
        this.raf = 0;

        this.initEntrance();
        this.initCarousel();
        if (!this.reduce && this.dataset.tilt === 'true') this.initTilt();
      }

      disconnectedCallback() {
        (this.cleanups || []).forEach(function (fn) { fn(); });
        this.cleanups = [];
        if (this.raf) window.cancelAnimationFrame(this.raf);
      }

      on(target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        this.cleanups.push(function () { target.removeEventListener(type, fn, opts); });
      }

      /* ---------- Scroll-triggered entrance ---------- */
      initEntrance() {
        var self = this;
        if (!this.classList.contains('is-prep')) return;
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-in');
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            self.classList.add('is-in');
            io.disconnect();
          }
        }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
        io.observe(this);
        this.cleanups.push(function () { io.disconnect(); });
      }

      /* ---------- Carousel: arrows, progress, state ---------- */
      initCarousel() {
        var self = this;

        this.update = function () {
          self.raf = 0;
          var t = self.track;
          var max = t.scrollWidth - t.clientWidth;
          var left = t.scrollLeft;
          self.classList.toggle('is-scrollable', max > 4);
          if (self.prev) self.prev.disabled = left <= 2;
          if (self.next) self.next.disabled = left >= max - 2;
          if (self.bar && self.progress) {
            var w = self.progress.clientWidth;
            var barW = Math.max(w * (t.clientWidth / t.scrollWidth), 24);
            var x = max > 0 ? (left / max) * (w - barW) : 0;
            self.bar.style.width = barW + 'px';
            self.bar.style.transform = 'translate3d(' + x.toFixed(1) + 'px, 0, 0)';
          }
        };
        this.schedule = function () {
          if (!self.raf) self.raf = window.requestAnimationFrame(self.update);
        };

        this.on(this.track, 'scroll', this.schedule, { passive: true });
        this.on(window, 'resize', this.schedule, { passive: true });

        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(function () { self.schedule(); });
          ro.observe(this.track);
          this.cleanups.push(function () { ro.disconnect(); });
        }

        var go = function (dir) {
          var first = self.items[0];
          if (!first) return;
          var gap = parseFloat(window.getComputedStyle(self.track).columnGap) || 0;
          var step = first.getBoundingClientRect().width + gap;
          if (!step) return;
          var visible = Math.max(1, Math.floor((self.track.clientWidth + gap) / step));
          self.track.scrollBy({ left: dir * step * visible, behavior: self.reduce ? 'auto' : 'smooth' });
        };
        if (this.prev) this.on(this.prev, 'click', function () { go(-1); });
        if (this.next) this.on(this.next, 'click', function () { go(1); });

        this.update();
        window.setTimeout(this.schedule, 1200);
      }

      /* ---------- 3D tilt (mouse / pen only) ---------- */
      initTilt() {
        var self = this;
        var active = null;
        var rect = null;
        var pending = null;
        var moveRaf = 0;

        var rest = function (card) {
          if (!card) return;
          card.classList.remove('is-tracking');
          card.style.removeProperty('--ch-rx');
          card.style.removeProperty('--ch-ry');
          card.style.removeProperty('--ch-px');
          card.style.removeProperty('--ch-py');
        };
        var leave = function () {
          if (active) {
            rest(active);
            active = null;
          }
          rect = null;
        };

        this.on(this.track, 'pointermove', function (e) {
          if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
          var card = e.target.closest('.ch-sbs__card');
          if (!card) { leave(); return; }
          if (card !== active) {
            if (active) rest(active);
            active = card;
            rect = null;
            card.classList.add('is-tracking');
          }
          if (!rect) {
            var item = card.closest('.ch-sbs__item');
            rect = (item || card).getBoundingClientRect();
          }
          if (!rect.width || !rect.height) return;
          var nx = Math.max(-1, Math.min(1, ((e.clientX - rect.left) / rect.width - 0.5) * 2));
          var ny = Math.max(-1, Math.min(1, ((e.clientY - rect.top) / rect.height - 0.5) * 2));
          pending = { nx: nx, ny: ny };
          if (moveRaf) return;
          moveRaf = window.requestAnimationFrame(function () {
            moveRaf = 0;
            if (!active || !pending) return;
            active.style.setProperty('--ch-ry', (pending.nx * 8).toFixed(2) + 'deg');
            active.style.setProperty('--ch-rx', (-pending.ny * 6).toFixed(2) + 'deg');
            active.style.setProperty('--ch-px', (pending.nx * 5).toFixed(1) + 'px');
            active.style.setProperty('--ch-py', (pending.ny * 4).toFixed(1) + 'px');
          });
        });
        this.on(this.track, 'pointerleave', leave);
        this.on(this.track, 'scroll', function () { rect = null; }, { passive: true });
        this.cleanups.push(function () {
          if (moveRaf) window.cancelAnimationFrame(moveRaf);
        });
      }
    }

    window.customElements.define('caseone-shop-by-style', CaseOneShopByStyle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caseone-best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Register once only (safe for theme editor reloads) */
    if (!window.customElements || window.customElements.get('caseone-best-sellers')) return;

    var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    class CaseOneBestSellers extends HTMLElement {
      connectedCallback() {
        this.cleanups = [];
        this.reduce = !!(reduceQuery && reduceQuery.matches);
        this.track = this.querySelector('[data-ch-bs-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-ch-bs-prev]');
        this.next = this.querySelector('[data-ch-bs-next]');
        this.bar = this.querySelector('[data-ch-bs-bar]');
        this.progress = this.querySelector('.ch-bs__progress');
        this.live = this.querySelector('[data-ch-bs-live]');
        this.items = Array.prototype.slice.call(this.querySelectorAll('.ch-bs__item'));
        this.raf = 0;
        this.scrollTimer = 0;
        this.holdTimer = 0;
        this.moveRaf = 0;
        this.active = null;
        this.suppressClick = false;

        this.initEntrance();
        this.initFloat();
        this.initCarousel();
        this.initQuickAdd();
        if (!this.reduce && this.dataset.tilt === 'true') this.initTilt();
      }

      disconnectedCallback() {
        (this.cleanups || []).forEach(function (fn) { fn(); });
        this.cleanups = [];
        clearTimeout(this.scrollTimer);
        clearTimeout(this.holdTimer);
        if (this.raf) window.cancelAnimationFrame(this.raf);
        if (this.moveRaf) window.cancelAnimationFrame(this.moveRaf);
      }

      on(target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        this.cleanups.push(function () { target.removeEventListener(type, fn, opts); });
      }

      say(message) {
        var live = this.live;
        if (!live) return;
        live.textContent = '';
        window.setTimeout(function () { live.textContent = message; }, 30);
      }

      /* ---------- Scroll-triggered entrance ---------- */
      initEntrance() {
        var self = this;
        if (!this.classList.contains('is-prep')) return;
        if (!('IntersectionObserver' in window)) {
          this.classList.add('is-in');
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            self.classList.add('is-in');
            io.disconnect();
          }
        }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
        io.observe(this);
        this.cleanups.push(function () { io.disconnect(); });
      }

      /* ---------- Float only on cards that are on screen ---------- */
      initFloat() {
        if (this.reduce || !this.classList.contains('has-float') || !('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-seen', entry.isIntersecting);
          });
        }, { threshold: 0.25 });
        this.items.forEach(function (item) { io.observe(item); });
        this.cleanups.push(function () { io.disconnect(); });
      }

      /* ---------- Carousel: arrows, progress, state ---------- */
      initCarousel() {
        var self = this;

        this.update = function () {
          self.raf = 0;
          var t = self.track;
          var max = t.scrollWidth - t.clientWidth;
          var left = t.scrollLeft;
          self.classList.toggle('is-scrollable', max > 4);
          if (self.prev) self.prev.disabled = left <= 2;
          if (self.next) self.next.disabled = left >= max - 2;
          if (self.bar && self.progress) {
            var w = self.progress.clientWidth;
            var barW = Math.max(w * (t.clientWidth / t.scrollWidth), 24);
            var x = max > 0 ? (left / max) * (w - barW) : 0;
            self.bar.style.width = barW + 'px';
            self.bar.style.transform = 'translate3d(' + x.toFixed(1) + 'px, 0, 0)';
          }
        };
        this.schedule = function () {
          if (!self.raf) self.raf = window.requestAnimationFrame(self.update);
        };

        this.on(this.track, 'scroll', function () {
          self.schedule();
          self.classList.add('is-scrolling');
          clearTimeout(self.scrollTimer);
          self.scrollTimer = window.setTimeout(function () {
            self.classList.remove('is-scrolling');
          }, 140);
        }, { passive: true });
        this.on(window, 'resize', this.schedule, { passive: true });

        if ('ResizeObserver' in window) {
          var ro = new ResizeObserver(function () { self.schedule(); });
          ro.observe(this.track);
          this.cleanups.push(function () { ro.disconnect(); });
        }

        var go = function (dir) {
          var first = self.items[0];
          if (!first) return;
          var gap = parseFloat(window.getComputedStyle(self.track).columnGap) || 0;
          var step = first.getBoundingClientRect().width + gap;
          if (!step) return;
          var visible = Math.max(1, Math.floor((self.track.clientWidth + gap) / step));
          self.track.scrollBy({ left: dir * step * visible, behavior: self.reduce ? 'auto' : 'smooth' });
        };
        if (this.prev) this.on(this.prev, 'click', function () { go(-1); });
        if (this.next) this.on(this.next, 'click', function () { go(1); });

        this.update();
        window.setTimeout(this.schedule, 1200);
      }

      /* ---------- Quick add to cart ---------- */
      initQuickAdd() {
        var self = this;
        this.on(this, 'click', function (e) {
          var btn = e.target.closest('[data-ch-bs-add]');
          if (!btn || !self.contains(btn)) return;
          e.preventDefault();
          self.addToCart(btn);
        });
      }

      addToCart(btn) {
        var self = this;
        if (btn.classList.contains('is-loading') || !this.dataset.addUrl) return;
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id) return;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');

        fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.classList.add('is-added');
            self.say('Added to cart');
            document.dispatchEvent(new CustomEvent('caseone:cart-changed'));
            window.setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.removeAttribute('aria-busy');
            btn.classList.add('is-error');
            self.say('Could not add to cart. Please try again.');
            window.setTimeout(function () { btn.classList.remove('is-error'); }, 1800);
          });
      }

      /* ---------- 3D tilt: hover (mouse) + press-and-hold (touch) ---------- */
      initTilt() {
        var self = this;

        var rest = function (card) {
          if (!card) return;
          card.classList.remove('is-tracking', 'is-active');
          card.style.removeProperty('--ch-rx');
          card.style.removeProperty('--ch-ry');
          card.style.removeProperty('--ch-px');
          card.style.removeProperty('--ch-py');
        };

        var deactivate = function () {
          clearTimeout(self.holdTimer);
          if (self.active) {
            rest(self.active);
            self.active = null;
          }
        };

        var point = function (x, y) {
          var r = self.rect;
          if (!r || !r.width || !r.height) return;
          var nx = Math.max(-1, Math.min(1, ((x - r.left) / r.width - 0.5) * 2));
          var ny = Math.max(-1, Math.min(1, ((y - r.top) / r.height - 0.5) * 2));
          self.pending = { nx: nx, ny: ny };
          if (self.moveRaf) return;
          self.moveRaf = window.requestAnimationFrame(function () {
            self.moveRaf = 0;
            var p = self.pending;
            var card = self.active;
            if (!card || !p) return;
            card.style.setProperty('--ch-ry', (p.nx * 9).toFixed(2) + 'deg');
            card.style.setProperty('--ch-rx', (-p.ny * 7).toFixed(2) + 'deg');
            card.style.setProperty('--ch-px', (p.nx * 6).toFixed(1) + 'px');
            card.style.setProperty('--ch-py', (p.ny * 4).toFixed(1) + 'px');
          });
        };

        var activate = function (card, x, y) {
          if (self.active !== card) {
            if (self.active) rest(self.active);
            self.active = card;
            var media = card.querySelector('.ch-bs__media');
            self.rect = (media || card).getBoundingClientRect();
            card.classList.add('is-tracking', 'is-active');
          }
          point(x, y);
        };

        /* Mouse / pen hover */
        this.on(this.track, 'pointermove', function (e) {
          if (e.pointerType === 'touch') {
            if (self.holdTimer && (Math.abs(e.clientX - self.startX) > 10 || Math.abs(e.clientY - self.startY) > 10)) {
              clearTimeout(self.holdTimer);
              self.holdTimer = 0;
            }
            return;
          }
          var card = e.target.closest('.ch-bs__card');
          if (!card) { deactivate(); return; }
          activate(card, e.clientX, e.clientY);
        });
        this.on(this.track, 'pointerleave', function (e) {
          if (e.pointerType !== 'touch') deactivate();
        });

        /* Touch press-and-hold: lifts the product toward the press point */
        this.on(this.track, 'pointerdown', function (e) {
          self.suppressClick = false;
          if (e.pointerType === 'mouse') return;
          var card = e.target.closest('.ch-bs__card');
          if (!card || e.target.closest('.ch-bs__add')) return;
          self.startX = e.clientX;
          self.startY = e.clientY;
          clearTimeout(self.holdTimer);
          self.holdTimer = window.setTimeout(function () {
            self.holdTimer = 0;
            self.suppressClick = true;
            activate(card, self.startX, self.startY);
          }, 170);
        });
        var end = function (e) {
          if (e.pointerType === 'mouse') return;
          deactivate();
        };
        this.on(this.track, 'pointerup', end);
        this.on(this.track, 'pointercancel', end);

        /* A deliberate hold previews the lift; it should not also open the product */
        this.on(this.track, 'click', function (e) {
          if (self.suppressClick) {
            e.preventDefault();
            e.stopPropagation();
            self.suppressClick = false;
          }
        }, true);
      }
    }

    window.customElements.define('caseone-best-sellers', CaseOneBestSellers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caseone-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.customElements) return;

  class CaseOneHeader extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.drawer = this.querySelector('[data-co-drawer]');
      this.searchPanel = this.querySelector('[data-co-search]');
      this.countEl = this.querySelector('[data-co-count]');
      this.openName = null;
      this.lastTrigger = null;
      this.refreshTimer = null;

      this.handleClickBound = this.handleClick.bind(this);
      this.handleKeyBound = this.handleKey.bind(this);
      this.handleScrollBound = this.handleScroll.bind(this);
      this.handleCartBound = this.scheduleCartRefresh.bind(this);

      this.addEventListener('click', this.handleClickBound);
      document.addEventListener('keydown', this.handleKeyBound);
      window.addEventListener('scroll', this.handleScrollBound, { passive: true });

      [
        'cart:update',
        'cart:change',
        'cart:updated',
        'cart:refresh',
        'caseone:cart-changed'
      ].forEach((eventName) => {
        document.addEventListener(eventName, this.handleCartBound);
      });

      this.handleScroll();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickBound);
      document.removeEventListener('keydown', this.handleKeyBound);
      window.removeEventListener('scroll', this.handleScrollBound);

      [
        'cart:update',
        'cart:change',
        'cart:updated',
        'cart:refresh',
        'caseone:cart-changed'
      ].forEach((eventName) => {
        document.removeEventListener(eventName, this.handleCartBound);
      });

      clearTimeout(this.refreshTimer);
      document.documentElement.classList.remove('co-lock');
      this._initialized = false;
    }

    handleScroll() {
      this.classList.toggle('is-scrolled', window.scrollY > 8);

      if (this.hasAttribute('data-sticky')) {
        const wrapper = this.closest('.shopify-section');
        if (wrapper) wrapper.classList.add('co-sticky-wrap');
      }
    }

    handleClick(event) {
      const opener = event.target.closest('[data-co-open]');

      if (opener && this.contains(opener)) {
        event.preventDefault();
        this.open(opener.dataset.coOpen, opener);
        return;
      }

      const closer = event.target.closest('[data-co-close]');

      if (closer && this.contains(closer)) {
        event.preventDefault();
        this.close(true);
        return;
      }

      const link = event.target.closest('a[href]');

      if (
        link &&
        this.openName &&
        ((this.drawer && this.drawer.contains(link)) ||
        (this.searchPanel && this.searchPanel.contains(link)))
      ) {
        this.close(false);
      }
    }

    open(name, trigger) {
      if (this.openName === name) {
        this.close(true);
        return;
      }

      this.close(false);
      this.openName = name;
      this.lastTrigger = trigger || document.activeElement;

      this.setAttribute('data-open', name);
      document.documentElement.classList.add('co-lock');

      this.querySelectorAll('[data-co-open]').forEach((button) => {
        button.setAttribute(
          'aria-expanded',
          button.dataset.coOpen === name ? 'true' : 'false'
        );
      });

      if (this.drawer) {
        this.drawer.setAttribute('aria-hidden', name === 'menu' ? 'false' : 'true');
      }

      if (this.searchPanel) {
        this.searchPanel.setAttribute('aria-hidden', name === 'search' ? 'false' : 'true');
      }

      requestAnimationFrame(() => {
        if (name === 'search') {
          const input = this.querySelector('.co-search-input');
          if (input) input.focus();
        } else if (name === 'menu') {
          const closeButton = this.drawer && this.drawer.querySelector('[data-co-close]');
          if (closeButton) closeButton.focus();
        }
      });
    }

    close(restoreFocus) {
      if (!this.openName) return;

      this.openName = null;
      this.removeAttribute('data-open');
      document.documentElement.classList.remove('co-lock');

      this.querySelectorAll('[data-co-open]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      if (this.drawer) this.drawer.setAttribute('aria-hidden', 'true');
      if (this.searchPanel) this.searchPanel.setAttribute('aria-hidden', 'true');

      if (restoreFocus && this.lastTrigger && this.lastTrigger.focus) {
        this.lastTrigger.focus();
      }

      this.lastTrigger = null;
    }

    handleKey(event) {
      if (!this.openName) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close(true);
        return;
      }

      if (event.key !== 'Tab') return;

      const panel = this.openName === 'menu' ? this.drawer : this.searchPanel;
      if (!panel) return;

      const focusable = panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), summary'
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    scheduleCartRefresh() {
      clearTimeout(this.refreshTimer);

      this.refreshTimer = setTimeout(() => {
        fetch(this.dataset.cartUrl, {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
          .then((response) => {
            if (!response.ok) throw new Error('Cart request failed');
            return response.json();
          })
          .then((cart) => this.setCartCount(cart.item_count))
          .catch(() => {});
      }, 80);
    }

    setCartCount(count) {
      if (!this.countEl) return;

      count = parseInt(count, 10) || 0;
      this.countEl.textContent = count > 99 ? '99+' : String(count);
      this.countEl.classList.toggle('is-empty', count === 0);

      const cartLink = this.querySelector('.co-cart');
      if (cartLink) {
        cartLink.setAttribute(
          'aria-label',
          'Shopping bag, ' + count + (count === 1 ? ' item' : ' items')
        );
      }
    }
  }

  if (!window.customElements.get('caseone-header')) {
    window.customElements.define('caseone-header', CaseOneHeader);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caseone-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Register once only. Used only to pause the float animation when the
       hero is off screen or the tab is hidden (saves battery on phones). */
    if (!window.customElements || window.customElements.get('caseone-hero-v2')) return;

    class CaseOneHeroV2 extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.setAttribute('data-inview', 'true');
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (entries) {
            self.setAttribute('data-inview', entries[0].isIntersecting ? 'true' : 'false');
          }, { threshold: 0 });
          this.io.observe(this);
        }
        this.onVis = function () {
          self.setAttribute('data-hidden', document.hidden ? 'true' : 'false');
        };
        document.addEventListener('visibilitychange', this.onVis);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
      }
    }

    window.customElements.define('caseone-hero-v2', CaseOneHeroV2);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caseone-shop-by-style"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(section){
    if(!section||section.dataset.sbsReady==='true')return;
    section.dataset.sbsReady='true';
    var grid=section.querySelector('[data-sbs-grid]'),progress=section.querySelector('[data-sbs-progress]'),bar=section.querySelector('[data-sbs-bar]');
    if(!grid||!progress||!bar)return;
    function update(){
      var max=grid.scrollWidth-grid.clientWidth,w=progress.clientWidth;
      var bw=Math.max(24,w*(grid.scrollWidth?grid.clientWidth/grid.scrollWidth:1));
      var x=max>0?(grid.scrollLeft/max)*(w-bw):0;
      bar.style.width=bw+'px';bar.style.transform='translateX('+x+'px)';
    }
    grid.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});update();
  }
  function scan(root){(root||document).querySelectorAll('[id^="CaseOneStyle-"]').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){scan(document)},{once:true})}else{scan(document)}
  document.addEventListener('shopify:section:load',function(e){scan(e.target)})
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caseone-stats-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Register once only (safe for theme editor reloads) */
    if (!window.customElements || window.customElements.get('caseone-stats-bar')) return;

    var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    /* Same 3-digit grouping as the Liquid side: 1000 -> 1,000 */
    function format(n) {
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    class CaseOneStatsBar extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.finished = false;
        this.raf = 0;
        this.io = null;

        this.stats = Array.prototype.slice.call(this.querySelectorAll('[data-ch-stat]'))
          .map(function (el) {
            return {
              value: el.querySelector('[data-ch-value]'),
              target: Math.max(0, parseInt(el.getAttribute('data-target'), 10) || 0)
            };
          })
          .filter(function (stat) { return stat.value; });

        var motionOk = !(reduceQuery && reduceQuery.matches);
        this.duration = (parseFloat(this.dataset.duration) || 2) * 1000;
        this.stagger = this.dataset.stagger === 'true' ? 120 : 0;

        /* No animation wanted or possible: the final numbers are already in the HTML */
        if (this.dataset.animate !== 'true' || !motionOk || !this.stats.length || !('IntersectionObserver' in window)) {
          return;
        }

        /* Start from 0 (the + and % stay visible; they are not part of the counted value) */
        this.stats.forEach(function (stat) { stat.value.textContent = format(0); });

        this.onShow = function (e) { if (e.persisted) self.finish(); };
        window.addEventListener('pageshow', this.onShow);

        this.io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting && !self.finished) {
            self.io.disconnect();
            self.io = null;
            self.run();
          }
        }, { threshold: 0.4 });
        this.io.observe(this);
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.raf) window.cancelAnimationFrame(this.raf);
        if (this.onShow) window.removeEventListener('pageshow', this.onShow);
      }

      run() {
        var self = this;
        var start = null;

        var frame = function (ts) {
          if (start === null) start = ts;
          var elapsed = ts - start;
          var allDone = true;

          self.stats.forEach(function (stat, i) {
            var t = (elapsed - i * self.stagger) / self.duration;
            if (t < 1) allDone = false;
            t = Math.max(0, Math.min(1, t));
            var eased = 1 - Math.pow(1 - t, 3);
            stat.value.textContent = format(stat.target * eased);
          });

          if (allDone) {
            self.finish();
          } else {
            self.raf = window.requestAnimationFrame(frame);
          }
        };
        this.raf = window.requestAnimationFrame(frame);
      }

      finish() {
        if (this.raf) window.cancelAnimationFrame(this.raf);
        this.raf = 0;
        this.finished = true;
        if (this.io) { this.io.disconnect(); this.io = null; }
        this.stats.forEach(function (stat) { stat.value.textContent = format(stat.target); });
      }
    }

    window.customElements.define('caseone-stats-bar', CaseOneStatsBar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caseone-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Register once only. If the section or this script is loaded more than
       once, only the first button on the page stays visible. */
    if (!window.customElements || window.customElements.get('caseone-whatsapp')) return;

    function showOnlyFirst() {
      var all = document.querySelectorAll('caseone-whatsapp');
      Array.prototype.forEach.call(all, function (el, i) {
        el.hidden = i > 0;
      });
    }

    class CaseOneWhatsApp extends HTMLElement {
      connectedCallback() {
        showOnlyFirst();
      }
      disconnectedCallback() {
        window.setTimeout(showOnlyFirst, 0);
      }
    }

    window.customElements.define('caseone-whatsapp', CaseOneWhatsApp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
